import React from 'react';
import './community.scss';
import EXPERT_LADY_01 from 'assets/home-page/expert_lady_01.png';
import EXPERT_LADY_02 from 'assets/home-page/expert_lady_02.png';
import {ReactComponent as DOT_ELEMENT} from 'assets/home-page/elements/dot_element_01.svg'
import {Button, HeadingElement} from "../../../../components";
import {useNavigate} from "react-router-dom";

export const Community: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div className={'community'}>
            <div className="community_wrapper max">

                <div className="community_wrapper_top">
                    <div className="community_wrapper_top_left">
                        <HeadingElement/>
                        <h1>Meet With Expert Advisors</h1>
                        <p>We provide an extensive team of experts to assist you with all the intricacies that comes
                            along with planning, starting and growing a business.</p>
                        <Button text={'Join Us'} type={'primary'} onclick={()=>navigate('/registration/#')}/>

                    </div>
                    <div className="community_wrapper_top_right">
                        <div className="community_wrapper_top_right_image_1">
                            <img src={EXPERT_LADY_01} alt=""/>
                            <DOT_ELEMENT id={'fist_image'}/>
                        </div>
                        <div className="community_wrapper_top_right_image_2">
                            <img src={EXPERT_LADY_02} alt=""/>
                        <div className="community_wrapper_top_right_image_2_shadow"/>

                        </div>
                    </div>
                </div>
                <div className="community_wrapper_bottom">
                    <div className="community_wrapper_bottom_left">
                        <div className="community_wrapper_bottom_left_content">
                            <div className="community_wrapper_bottom_left_content_child">
                                <span className="number">40+</span>
                                <span className="text">Conferences</span>
                            </div>
                            <div className="community_wrapper_bottom_left_content_child">
                                <span className="number">200+</span>
                                <span className="text">Members</span>
                            </div>
                            {/*<div className="community_wrapper_bottom_left_content_child">*/}
                            {/*    <span className="number">46+</span>*/}
                            {/*    <span className="text">Partners</span>*/}
                            {/*</div>*/}
                        </div>
                        <div className="community_wrapper_bottom_left_desc">
                            <p>Save time, money, and resources with Small Business Association of Jamaica. We want to
                                see you plan, start and grow your business.</p>
                        </div>
                    </div>
                    <div className="community_wrapper_bottom_right">
                        <HeadingElement/>
                        <h1>Unleash the full power of Community</h1>
                        <p>
                            Information changes a lot, and so does our growing community of business partners and members that are here to ensure that you are informed and current in all aspects of your Business.
                        </p>
                        <Button text={'Learn More'} type={'primary'} onclick={()=>navigate('/business-education/#')}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Community;
